import { subscribeEmbedViewport } from "./embedViewport";

const HEIGHT_MESSAGE = "rentalls-iframe-height";

// Reports the height of the app to the page that embeds it, which gives the
// iframe that height. Browsers pause ResizeObserver in cross-origin iframes
// that are off screen, so DOM changes, loaded images, scrolling of the page
// and a check every second report the height too. Equal heights are sent once.
export const startHeightReporting = (win = window, { interval = 1000 } = {}) => {
  if (win.parent === win) {
    return () => {};
  }

  const doc = win.document;
  let lastHeight = null;
  let scheduled = false;

  const report = () => {
    scheduled = false;
    const height = doc.body.scrollHeight;
    if (height === lastHeight) return;
    lastHeight = height;
    win.parent.postMessage({ type: HEIGHT_MESSAGE, height }, "*");
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    win.setTimeout(report, 0);
  };

  const resizeObserver =
    typeof win.ResizeObserver === "function" ? new win.ResizeObserver(schedule) : null;
  resizeObserver?.observe(doc.body);
  const mutationObserver =
    typeof win.MutationObserver === "function" ? new win.MutationObserver(schedule) : null;
  mutationObserver?.observe(doc.body, { childList: true, subtree: true, characterData: true });
  // Images and other resources change the height when they load.
  doc.addEventListener("load", schedule, true);
  const timer = win.setInterval(report, interval);
  const unsubscribe = subscribeEmbedViewport(schedule);
  report();

  return () => {
    resizeObserver?.disconnect();
    mutationObserver?.disconnect();
    doc.removeEventListener("load", schedule, true);
    win.clearInterval(timer);
    unsubscribe();
  };
};
